module.exports = __webpack_public_path__ + "images/emoji/koala.e80213b940d6ab4d14c0.png";